// extracted by mini-css-extract-plugin
module.exports = {"sort":"GQ","sortSelect":"HQ","disabled":"IQ"};